export var printTemplate = /\$([\w.]+)/g;